import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";

export default {
  state: {},
  getters: {},
  actions: {
    // ---- task templates (library) ----
    getTaskTemplates({}) {
      return new Promise((resolve, reject) => {
        axios.get(`${BASE_URL}/events/taskSystem/templates`).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    getTaskTemplate({}, templateId) {
      return new Promise((resolve, reject) => {
        axios.get(`${BASE_URL}/events/taskSystem/template/${templateId}`).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    createTaskTemplate({}, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/events/taskSystem/template`, payload).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    updateTaskTemplate({}, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`${BASE_URL}/events/taskSystem/template/${payload.templateId}`, payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    deleteTaskTemplate({}, templateId) {
      return new Promise((resolve, reject) => {
        axios.delete(`${BASE_URL}/events/taskSystem/template/${templateId}`).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },

    // ---- event stage tasks (per-event instances) ----
    getEventStageTasks({}, payload) {
      return new Promise((resolve, reject) => {
        let query = [];
        if (payload.level) query.push(`level=${encodeURIComponent(payload.level)}`);
        if (payload.stage) query.push(`stage=${payload.stage}`);
        const qs = query.length ? `?${query.join('&')}` : '';
        axios.get(`${BASE_URL}/events/taskSystem/event/${payload.eventId}/tasks${qs}`).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    attachEventStageTask({}, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/events/taskSystem/event/${payload.eventId}/tasks`, payload).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    updateEventStageTask({}, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`${BASE_URL}/events/taskSystem/task/${payload.taskId}`, payload).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    archiveEventStageTask({}, taskId) {
      return new Promise((resolve, reject) => {
        axios.delete(`${BASE_URL}/events/taskSystem/task/${taskId}`).then(response => {
          resolve("success")
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },

    // ---- progress dashboard ----
    getTaskProgressSummary({}, eventId) {
      return new Promise((resolve, reject) => {
        axios.get(`${BASE_URL}/events/taskSystem/event/${eventId}/progress/summary`).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    getTaskProgressTeams({}, payload) {
      return new Promise((resolve, reject) => {
        let query = [];
        if (payload.level) query.push(`level=${encodeURIComponent(payload.level)}`);
        if (payload.stage) query.push(`stage=${payload.stage}`);
        const qs = query.length ? `?${query.join('&')}` : '';
        axios.get(`${BASE_URL}/events/taskSystem/event/${payload.eventId}/progress/teams${qs}`).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    // team-centric matrix: all teams of an event, each with its per-task progress folded in
    getTaskProgressTeamMatrix({}, eventId) {
      return new Promise((resolve, reject) => {
        axios.get(`${BASE_URL}/events/taskSystem/event/${eventId}/progress/teamMatrix`).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    },
    reviewTaskProgress({}, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/events/taskSystem/progress/${payload.progressId}/review`, payload).then(response => {
          resolve(response.data.data)
        }).catch(error => {
          reject(error.response ? error.response.data : error)
        })
      })
    }
  },
  mutations: {}
}
